import moment from "moment";

function isoDateToDDMMYYYY(isoDateString) {
  return moment(isoDateString).format("DD/MM/YYYY");
}

export default isoDateToDDMMYYYY;
